import { Input, Modal, Popover, Tag } from "antd";
import React from "react";
import { ICONS } from "../../../../assets/icons";
import Header from "../../../../components/commonComponents/modals/Header";

const CreateTeamModal = ({
  isModalVisible,
  handleCancel,
  handleCreate,
  handleUpdate,
  updateTrue,
  handleInvite,
  enableCreate,
  newTeamName,
  setNewTeamName,
  creationError,
  multipleLeaders,
  multipleMembers,
  handleSelectLeader,
  handleSelect,
  removeLeaders,
  removeMembers,
  showRoles,
  currentStep,
  isChecked,
}) => {
  const steps = ["Step 1", "Step 2"];
  console.log({showRoles});
  

  console.log(multipleLeaders, multipleMembers);

  return (
    <Modal
      open={isModalVisible}
      closable={false}
      footer={[
        <button
          key="cancel"
          onClick={handleCancel}
          className="border border-[var(--card-border)] text-[var(--font-600)] font13px-400 px-4 py-1 b-radius-6"
        >
          Cancel
        </button>,
        <>
          {currentStep === 2 && (
            <>
              {enableCreate() ? (
                <button
                  className="bg-[var(--new-primary)] text-white px-4 py-1 b-radius-6 ml-15 cursor-pointer"
                  onClick={() => {
                    handleInvite();
                  }}
                >
                  Invite
                </button>
              ) : (
                <span className="bg-[var(--BG-50)] text-[var(--font-600)] px-4 py-1.5 b-radius-6 ml-15 cursor-not-allowed">
                  Invite
                </span>
              )}
            </>
          )}
        </>,
        <>
          {currentStep === 1 && (
            <>
              {enableCreate() ? (
                <button
                  className="bg-[var(--new-primary)] text-white px-4 py-1 b-radius-6 ml-15 cursor-pointer"
                  onClick={() => {
                    if (updateTrue) {
                      handleUpdate();
                    } else {
                      handleCreate();
                    }
                  }}
                >
                  {updateTrue && isChecked
                    ? "Update"
                    : !isChecked
                    ? "Next"
                    : "Create"}
                </button>
              ) : (
                <span className="bg-[var(--BG-50)] text-[var(--font-600)] px-4 py-1.5 b-radius-6 ml-15 cursor-not-allowed">
                  Create
                </span>
              )}
            </>
          )}
        </>,
      ]}
    >
      <div className={"w-full h-auto flex flex-col"}>
        <Header
          title={currentStep === 1 ? "Create Team" : "Invite"}
          handleCancel={handleCancel}
          rootStyle="px-0 py-0"
        />
        {/* Stepper */}
        <div className="w-80 ml-40 flex mb-10 mt-10">
          {steps.map((label, index) => {
            const stepNumber = index + 1;
            const isCompleted = stepNumber < currentStep;
            const isActive = stepNumber === currentStep;

            return (
              <React.Fragment key={label}>
                <div className="flex flex-col items-center">
                  <div
                    className={`w-5 h-5 rounded-full flex items-center justify-center border-2 transition-all duration-200 ${
                      isCompleted
                        ? "border-green-600 bg-green-600 text-white"
                        : isActive
                        ? "border-green-600 bg-white text-green-600"
                        : "border-gray-300 bg-white text-gray-300"
                    }`}
                  >
                    {isCompleted ? (
                      <span className="text-xs font-bold">✔</span>
                    ) : (
                      <span className="text-xs font-semibold">
                        {stepNumber}
                      </span>
                    )}
                  </div>
                  <span
                    className={`mt-2 text-sm font-medium ${
                      isCompleted || isActive
                        ? "text-green-600"
                        : "text-gray-400"
                    }`}
                  >
                    {label}
                  </span>
                </div>

                {/* Connector line */}
                {index < steps.length - 1 && (
                  <div className="h-0.5 flex-1 bg-gray-300 mx-2 mt-2" />
                )}
              </React.Fragment>
            );
          })}
        </div>

        {/* Step-1 Content (Team Name, Leader, Members) */}
        {currentStep === 1 && (
          <div>
            <span className="font14px-500 text-[var(--textBlack)]">
              Team Name <span className="text-red-500">*</span>
            </span>
            <Input
              placeholder="Enter team name"
              value={newTeamName}
              onChange={(e) => {
                const cleaned = e.target.value.replace(/[^a-zA-Z0-9 ]/g, "");
                setNewTeamName(cleaned);
              }}
              className={`mt-10 ${
                newTeamName?.endsWith("'") ||
                newTeamName?.endsWith("-") ||
                newTeamName?.endsWith(".") ||
                creationError
                  ? "border-red-500"
                  : ""
              }`}
              maxLength={60}
              showCount
            />
            {creationError && (
              <span className="text-red-500 text-sm mt-1 block">
                {creationError}
              </span>
            )}
          </div>
        )}

        {/* Team Leader Section */}
        {currentStep === 2 && (
          <>
            <span className="font14px-500 text-[var(--textBlack)] mt-10">
              Team Leader <span className="text-red-500">*</span>
            </span>
            <Popover
              trigger="click"
              placement="bottomLeft"
              arrow={false}
              content={
                <div className="w-[31vw] bg-white rounded-md shadow max-h-60 overflow-y-auto px-2">
                  {showRoles?.data?.map((option) => {
                    // ROLE 10 is team member, so we skip it
                    if (option?.role_id === 10) return;
                    const isSelected =
                      multipleLeaders?.length > 0 &&
                      multipleLeaders.some(
                        (v) => v?.id == option?.id
                      );
                    const removed =
                      multipleMembers?.length > 0 &&
                      multipleMembers.some(
                        (v) => v?.user_id == option?.user_id
                      );
                    if (removed) return;
                    return (
                      <div
                        key={option?.id}
                        onClick={() => handleSelectLeader(option)}
                        className={`flex justify-between px-2 py-2 rounded-md cursor-pointer border-b capitalize mt-5 mb-5 ${
                          isSelected
                            ? "bg-[var(--new-primary-bg)] text-[var(--new-primary)]"
                            : "hover:bg-slate-100"
                        }`}
                      >
                        {option?.first_name + " " + option?.last_name} ({option?.email}) ({option?.role_name})
                      </div>
                    );
                  })}
                </div>
              }
            >
              <div className="flex justify-between items-center mt-3 border border-[var(--border-input)] px-3 py-2 rounded-md">
                <div>
                  <p className="text-[var(--font-600)]">Selected:</p>
                  {multipleLeaders?.map((val) => {
                    console.log(val);
                    return (
                      <Tag
                        key={val.first_name}
                        closable={!val?.status ? true : false}
                        onClose={() => removeLeaders(val)}
                      >
                        {val.first_name}
                      </Tag>
                    );
                  })}
                </div>
                <img src={ICONS?.chevronDownCarousel} alt="" />
              </div>
            </Popover>

            {/* Team Members Section */}
            <span className="font14px-500 text-[var(--textBlack)] mt-10">
              Team Members <span className="text-red-500">*</span>
            </span>
            <Popover
              placement="bottomLeft"
              trigger="click"
              arrow={false}
              content={
                <div className="w-[31vw]  bg-white rounded-md shadow max-h-60 overflow-y-auto px-2">
                  {showRoles?.data?.map((option) => {
                    // ROLE 9 is team leader, so we skip it
                    if (option?.role_id === 9) return;

                    const isSelected =
                      multipleMembers?.length > 0 &&
                      multipleMembers.some(
                        (v) => v?.id == option?.id
                      );
                    const removed =
                      multipleLeaders?.length > 0 &&
                      multipleLeaders.some(
                        (v) => v?.user_id == option?.user_id
                      );
                    if (removed) return;
                    return (
                      <div
                        key={option?.id}
                        onClick={() => handleSelect(option)}
                        className={`flex justify-between px-2 py-2 rounded-md cursor-pointer border-b capitalize mt-5 mb-5 ${
                          isSelected
                            ? "bg-[var(--new-primary-bg)] text-[var(--new-primary)]"
                            : "hover:bg-slate-100"
                        }`}
                      >
                        {option?.first_name + " " + option?.last_name} ({option?.email}) ({option?.role_name})
                      </div>
                    );
                  })}
                </div>
              }
            >
              <div className="flex justify-between items-center mt-3 border border-[var(--border-input)] px-3 py-2 rounded-md">
                <div>
                  <p className="text-[var(--font-600)]">Selected:</p>
                  {multipleMembers?.map((val) => {
                    return (
                      <Tag
                        key={val.first_name}
                        closable={!val?.status ? true : false}
                        onClose={() => removeMembers(val)}
                        className="capitalize"
                      >
                        {val.first_name + " " + val.last_name}
                      </Tag>
                    );
                  })}
                </div>
                <img src={ICONS?.chevronDownCarousel} alt="" />
              </div>
            </Popover>
          </>
        )}
      </div>
    </Modal>
  );
};

export default CreateTeamModal;
